<template>
  <div class="business-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/business/banner.jpg">
    <div class="site-text__content">
      <h3 class="text-blue site-text__content_h3">与“城市力"共澎湃</h3>
      <div class="site-text__content_desc">
        <p>嘉宏商业围绕“3+1”产品线布局规划，全面运营</p>
        <p>星光天地、星光城、星光里和灯贸中心。</p>
      </div>
    </div>
    <div class="mode-content">
       <div style="">
        <p class="slider__tips slider__tips_no" :class="{'slider__tips_inView':isMobile}">
          左右滑动查看更多
        </p>
        <div class="three_slider__content">
          <div class="slider_xg three_slider__content_ne">
            <div v-for="(item,index) in vehicles" :key="index" class="slider__content_item">
              <img :src="require('@/assets/business/' + item.image.desktop)" class="slider__content_item_img" draggable="false">
              <div class="content-one-bottom">
                <div class="fs16">{{item.name}}</div>
                <div class="line">
                    <div class="blue-line"></div>
                </div>
              </div>
              <div class="slider__content_mask">
                  <div>
                      <div class="title">{{item.name}}</div>
                      <div class="bg_line">
                          <div class="bg_line_min"></div>
                      </div>
                      <div class="mask_desc">
                          <pre style="position:absolute;top: 0;">{{item.desc}}</pre>
                          <pre style="color:transparent;">嘉宏孟河星光城地处齐梁故里、汽配名地--孟河镇，坐落于常州市新北区孟河大道与S239交叉口西北侧，定位一站式全业态商业综合体，集合五星级酒店、高端住宅、综合体及沿街商业，营造孟河商业新中心，打造符合孟河人民消费习惯、吸引周边乡镇居民消费的全生活中心集聚地。
项目总体量8万方，拥有超百家国内外知名品牌入驻，更有500强企业温德姆酒店集团“温德姆”品牌首进常州，成为孟河镇首家五星级酒店!
</pre>
                      </div>
                      <div class="mask_img_content">
                          <img :src="require('@/assets/business/' + item.code)">
                          <div v-if="index == vehicles.length-1" class="no-open">规划中...</div>
                      </div>
                      <div class="mask_img_text">微信公众号</div>
                  </div>
                  <div class="mask_address_content">
                    <div class="item-row">
                        <img src="@/assets/business/address1.png">
                        <span>{{item.address}}</span>
                    </div>
                      <div class="item-row">
                          <img src="@/assets/business/phone1.png">
                          <span>{{item.phone}}</span>
                      </div>
                  </div>
              </div>
            </div>
          </div>
          <div v-if="isMobile" class="Carousel_carouselControls__HecEP carouselControls">
             <div class="Carousel_carouselPagination__dClSG carouselPagination">
                <span v-for="(item,index) in vehicles" :key="index"
                      class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                      :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':currentSlide1===index}">
                </span>
             </div>
          </div>
        </div>
      </div>
        <div class="middle-container">
            <div class="middle_content_item">
                <span>5</span>
                <span>个</span>
                <div>开业商场数量</div>
            </div>
            <div class="middle_line"></div>
            <div class="middle_content_item">
                <span>680</span>
                <span>+个</span>
                <div>合作品牌</div>
            </div>
            <div class="middle_line"></div>
            <div class="middle_content_item">
                <span>300</span>
                <span>+个</span>
                <div>战略合作品牌</div>
            </div>
        </div>
        <div class="hx-content">
<!--            <div class="hx-content-title">-->
<!--                <h3 class="text-blue site-text__content_h3">核心优势</h3>-->
<!--            </div>-->
        </div>
        <div class="jc-content NioHouseFunction_nioHouseFunctionContainer__Slqkp">
            <div class="star-content">
                <div class="star-title-content">
                    <h3 class="text-blue">精彩瞬间</h3>
                </div>
            </div>
            <div class="slider-jc jc-slider_content">
                <div v-for="(item,index) in jcList" :key="index">
                    <div class="jc-slider_item">
                        <img :src="require('@/assets/business/' + item.image)"/>
                        <div class="jc-slider_bottom">
                            <span>{{item.name}}</span>
                            <span>{{item.desc}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Carousel_carouselControls__HecEP carouselControls">
                  <div v-if="!isMobile" class="Carousel_carouselArrowWrapper__7vECO" @click="carouseClick('prev')">
                      <div class="Carousel_carouselArrow__YV3L6 carouselArrowPrev">
                          <i></i>
                          <i></i>
                      </div>
                  </div>
                <div class="Carousel_carouselPagination__dClSG carouselPagination">
                    <span v-for="(item,index) in jcList" :key="index"
                          class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                          :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':currentSlide2===index}">
                    </span>
                </div>
                  <div v-if="!isMobile" class="Carousel_carouselArrowWrapper__7vECO" @click="carouseClick('next')">
                      <div class="Carousel_carouselArrow__YV3L6 Carousel_carouselArrowNext__o36BS carouselArrowNext">
                          <i></i>
                          <i></i>
                      </div>
                  </div>
            </div>
        </div>
        <div class="star-content">
            <div class="star-title-content">
                <h3 class="text-blue">合作品牌</h3>
                <div class="en-text text-up">COOPERATIVE BRANDS</div>
            </div>
        </div>

        <div class="community-content">
            <div class="community-bg">
                <div v-for="(item,index) in 48" :key="index" class="community-item">
                    <img :src="require('@/assets/business/co/' + (index+1) + '.jpg')"/>
                </div>
            </div>
        </div>
    </div>


  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
var that = null
export default {
  name: "business",
  components:{
    topNav
  },
  data() {
    return {
      isMobile:false,
      currentSlide1:0,
        currentSlide2:0,
      sliderIndex: 0,
      vehicles: [
        {
          "image": {
            "desktop": "slide1.jpg",
            "mobile": "slide1.jpg"
          },
          name:'星光天地',
            desc:'嘉宏星光天地，地处常州市中心，吊桥路与晋陵路交叉口;商场建筑面积30000㎡，\n' +
                '商场定位“高品质青少年艺术基地，女性悦荟美颜社享中心”。是集海洋探索馆、高品质影院、高端齿科、高端美容养生、儿童艺术培训、网红轻餐等一体的精致购物休闲游乐广场。\n',
          address:'江苏省常州市钟楼区晋陵路与吊桥路交叉口西南侧',
          phone:'0519-89190020',
          code:'code1.png'
        },
        {
          "image": {
            "desktop": "slide2.jpg",
            "mobile": "slide2.jpg"
          },
            name:'孟河星光城',
            desc:'嘉宏孟河星光城地处齐梁故里、汽配名地--孟河镇，坐落于常州市新北区孟河大道与S239交叉口西北侧，定位一站式全业态商业综合体，集合五星级酒店、高端住宅、综合体及沿街商业，营造孟河商业新中心，打造符合孟河人民消费习惯、吸引周边乡镇居民消费的全生活中心集聚地。\n' +
                '项目总体量8万方，拥有超百家国内外知名品牌入驻，更有500强企业温德姆酒店集团“温德姆”品牌首进常州，成为孟河镇首家五星级酒店!\n',
            address:'江苏省常州市新北区孟河镇孟河大道转盘中心西南侧',
            phone:'0519-88110090',
            code:'code2.png'
        },
        {
          "image": {
            "desktop": "slide3.jpg",
            "mobile": "slide3.jpg"
          },
            name:'奔牛星光城',
            desc:'奔牛星光城位于教育重镇奔牛镇,奔牛教育体系完善,名校资源丰富，区域消费实力强劲，项目商业体量\n' +
                '3.5万方，定位家庭生活娱乐为中心,汇集购物中心、高端酒店、金街、都会奢宅四大业态,结合综合菜市、公交枢纽等高端服务配套,囊括影院、超市、餐饮、零售业态,项目将塑造星系范本,为奔牛带来全新消费体验。',
            address:'江苏省常州市新北区奔牛镇南观路和兴奔路交叉口西北侧',
            phone:'0519-85800028',
            code:'code3.png'
        },
        {
          "image": {
            "desktop": "slide4.jpg",
            "mobile": "slide4.jpg"
          },
            name:'空港星光城',
            desc:'空港国际星光城坐落于常州空港强镇罗溪镇，距离常州机场仅4KM，8万方商业体聚集70+焕新品牌，配套法国雅高集团旗下五星级标准美爵酒店及1万方高端宴会餐饮“金宝铂晶盛宴”，成就空港生活消费新地标。',
            address:'江苏省常州市新北区黄河西路与通达路交汇处',
            phone:'0519-85800028',
            code:'code4.png'
        },
          {
              "image": {
                  "desktop": "slide5.jpg",
                  "mobile": "slide5.jpg"
              },
              name:'嘉宏灯贸中心',
              desc:'华东区规模最大灯饰商场，服务辐射华东区域，联手数百家国内外知名灯具品牌，打造“高端一站式灯具体验中心”，为广大客户提供灯具体验、展示、设计等全方位服务。\n',
              address:'江苏省常州市钟楼区邹区镇东方大道与312国道交叉口西南侧',
              phone:'0519-83389888',
              code:'code5.png'
          },
          {
              "image": {
                  "desktop": "slide6.jpg",
                  "mobile": "slide6.jpg"
              },
              name:'蔚蓝星光城',
              desc:'蔚蓝星光城位于常州东部产业新区一经开区，紧邻青洋路高架枢纽，交通便利。作为嘉宏集团布局龙城东部的一钻，项目倾力打造儿童乐园基地、健康运动社交场及家庭式消费共享空间，致力于成为东大门璀璨之“星”。',
              address:'江苏省常州市武进经开区龙城大道与曙兴路交叉口东南侧',
              phone:'0519-85800028',
              code:'code6.png'
          }
      ],
      jcList:[
            {
                name:'空港星光城',
                desc:'璀璨绽放',
                image:'swiper1.jpg'
            },
            {
                name:'孟河星光城',
                desc:'浪漫气球雨',
                image:'swiper2.jpg'
            },
            {
                name:'星光天地',
                desc:'大黄鸭',
                image:'swiper3.jpg'
            },
            {
                name:'奔牛星光城',
                desc:'综艺表演',
                image:'swiper4.jpg'
            }
        ],
        hzList:[
            '1.png'
        ]
    }
  },
  mounted() {
    that = this
    this.initSlider();
    this.handleResize()
  },
  methods: {
      handleResize(){
          this.isMobile = window.innerWidth <= 720
      },
      paginationClick(index){
          that.currentSlide1 = index
          $('.slider_xg').slick('slickGoTo', index);
      },
    /**
     * 初始化轮播
     */
    initSlider() {
      this.$nextTick(() => {
        $('.slider_xg').slick({
          arrows: true,
          initialSlide: 0,
          slidesToShow: 3,
          slidesToScroll: 3,
          draggable:false,
          prevArrow: "<button type='button' class='slick-prev slick-arrow'><img class='prev-img' src=" + require('@/assets/business/prev.png') + "></button>",
          nextArrow: "<button type='button' class='slick-next slick-arrow'><img class='prev-img' src=" + require('@/assets/business/next.png') + "></button>",
          responsive: [
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    draggable:false,
                }
            },
              {
                  breakpoint: 721,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: false,
                      draggable:true,
                  }
              }
          ]
        });
          $('.slider_xg').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
              that.currentSlide1 = currentSlide
          });

          $('.slider-jc').slick({
              arrows: false,
              initialSlide: 0,
              slidesToShow: 1,
              slidesToScroll: 1,
          });
          $('.slider-jc').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
              that.currentSlide2 = currentSlide
          });
      });
    },
    /**
     * 轮播切换
     * @param index
     */
    pagination1Click(index){
      $('.slider1').slick('slickGoTo', index);
    },
      carouseClick(type){
        if(type == 'prev'){
            $(".slider-jc").slick("slickPrev");
        }else{
            $(".slider-jc").slick("slickNext");
        }
      },
  }
}
</script>

<style>
  @import "../../styles/business.css";
  /*@import "../../styles/aef8.css";*/
</style>
